/* global BigInt */
import React, { useContext, useEffect, useState } from "react"
import AppModal from "../../AppModal"
import { IconButton } from '../../';
import { AppContext } from "../../../providers/AppContext"
import MintModalSlider from "../MintModalSlider"
import MintModalHeader from './MintModalHeader'
import MintModalChoice from './MintModalChoice'
import { BROADSIDER_COLLECTION_URL, BASEJUMP_CONTRACT_ADDRESS } from '../../../constants';
import { openUrl } from '../../../utils'; 
import {
  useNavigate
} from "react-router-dom";
import { 
  StyledMintModal,
  ModalContentBackground,
  ModalContentHolder,
  ButtonContent,
  SelectedText,
  Content
} from "./MintModal.styled"

import { 
  MintModalPhaseOne,
} from "./MintModalPhaseOne.styled"

import {
  OgHolder,
  OgInfo,
  OgInfoRow,
  OgInfoLabel,
  OgInfoValue,
  OgSelector
} from "./MintModalPhaseTwo.styled"

import { 
  Figures,
  SliderContainer
} from "./MintModalPhaseThree.styled"


import Avatar from "../../Avatar"
import { theme } from "../../../theme"
import { getAllOgs, getAllNftsFromAlchemy } from "../../../providers/AlchemyProvider"
import { getOgPassesForTokens } from "../../../providers/OgPassProvider"
import { FigureModel } from "../../../models"

const MintModal = () => {
  const navigate = useNavigate();
  const [ogs, setOgs] = useState([]);
  const { mintFigures, setMintFigures, isMintingInProgress, requestMinting, accountAddress, setShowMintModal } = useContext(AppContext);

  useEffect(() => {
    //TODO modify usage to pass proper addresses / network
    (async () => {
      const models = await getAllOgs(accountAddress);
      const tokens = await getAllNftsFromAlchemy(accountAddress, BASEJUMP_CONTRACT_ADDRESS);
      const notMintedOgs = models.filter(o => !tokens.find(t => t.id === o.id));

      setOgs(notMintedOgs.map(e => {
        return {
          selected: false,
          model: FigureModel.fromAlchemyNft(e)
        }}
      ))
    })()
    
  }, [setOgs, accountAddress])

  const onOgMint = () => {
    setPhase(1);
  }

  const onNewMint = () => {
    requestMinting(mintFigures, []);
    setShowMintModal(false);
  }

  const onMintSelected = () => {
    setPhase(2)
  }

  const getOgPasses = async () => {
    const tokenIds = ogs.filter(o => o.selected).map(o => o.model.getId());
    const passes = await getOgPassesForTokens(tokenIds);
    return passes;
  };

  const onAddNewFigures = async () => {
    const passes = await getOgPasses();
    requestMinting(mintFigures, passes);
    setShowMintModal(false);
  }

  const onMintOgs = async () => {
    const passes = await getOgPasses();
    requestMinting(0, passes);
    setShowMintModal(false);
  }

  const onClickOpenSea = () => {
    openUrl(BROADSIDER_COLLECTION_URL);
  }

  const onClickApp = () => {
    navigate('/app');
  }

  const isMintOgsDisabled = !ogs.some(e => e.selected === true);

  const onSelectAll = () => {
    setOgs(
      [...ogs.map(e => {
        e.selected = true;
        return e
      })]
    )
  }

  const onSelect = (index) => {
    ogs[index].selected = !ogs[index].selected;
    setOgs([...ogs]);
  }

  const [phase, setPhase] = useState(0);
  const titles = ['Hello Warhead', 'Select OGs', 'Almost there...', 'Congratulations'];
  const phases = [
    (
      <MintModalPhaseOne>
        <ModalContentHolder>
          <Content>
            YOU HAVE <SelectedText>OG BROADSIDERS</SelectedText> IN YOUR WALLET, 
            WHICH MEANS YOU CAN MINT
          </Content>
        </ModalContentHolder>
        <ModalContentHolder>
          <IconButton onClick={onOgMint} animated={true}>
            <ButtonContent>
              <div>OG Action Figures</div>
              <img style={{paddingBottom: '6px'}} src='/assets/og.svg' alt=""/>
            </ButtonContent>
          </IconButton>
        </ModalContentHolder>
        <MintModalChoice/>
        <ModalContentHolder>
          <IconButton
            onClick={onNewMint}
            animated={true}
            borderOverwrite='rgba(0, 0, 0, .16)'
            borderOverwriteHover='rgba(0, 0, 0, .32)'
            backgroundOverwrite='white'>
            <ButtonContent>
              <div>non-OG Action Figures</div>
              <img style={{paddingBottom: '6px'}} src='/assets/bj.svg' alt=""/>
            </ButtonContent>
          </IconButton>
        </ModalContentHolder>
      </MintModalPhaseOne>
    ),
    (
      <MintModalPhaseOne>
        <ModalContentHolder>
          <Content>
            SELECT BROADSIDERS TO MINT AS <SelectedText>ACTION FIGURES</SelectedText>
          </Content>
        </ModalContentHolder>
        <ModalContentHolder>
          <IconButton
            animated={true}
            onClick={onSelectAll}>
            <ButtonContent>
              <img style={{paddingBottom: '6px'}} src='/assets/try_left.svg' alt=""/>
              <div>Select All</div>
              <img style={{paddingBottom: '6px'}} src='/assets/try_right.svg' alt=""/>
            </ButtonContent>
          </IconButton>
        </ModalContentHolder>
        <OgSelector>
          {ogs.map((f, index) => (
            <OgHolder onClick={() => onSelect(index)} key={`og-${index}-${f.model.name}`}>
              <Avatar 
                key={'selec' + index} 
                figure={f.model} 
                isSelected={ogs[index].selected}
                isHovered={false}
              />
              <OgInfo>
                <OgInfoRow>
                  <OgInfoLabel>OG </OgInfoLabel>
                  <OgInfoValue $selected={!!ogs[index].selected}>{f.model.getName()}</OgInfoValue>
                </OgInfoRow>
                <OgInfoRow>
                  <OgInfoLabel># </OgInfoLabel>
                  <OgInfoValue $selected={!!ogs[index].selected}>{f.model.getId()}</OgInfoValue>
                </OgInfoRow>
              </OgInfo> 
            </OgHolder>
          ))}
          <div className='selector-corner selector-corner-tl' />
          <div className='selector-corner selector-corner-tr' />
          <div className='selector-corner selector-corner-bl' />
          <div className='selector-corner selector-corner-br' />
        </OgSelector>
        <ModalContentHolder>
          <IconButton
            animated={true}
            backgroundOverwrite={theme.buttonGreen}
            backgroundOverwriteHover={theme.buttonLightGreen}
            borderOverwrite='rgba(0, 0, 0, .16)'
	    disabled={isMintOgsDisabled}
            onClick={onMintSelected}>
            <ButtonContent>
              <img style={{paddingBottom: '6px'}} src='/assets/og.svg' alt=""/>
              <div>Mint Selected</div>
              <img style={{paddingBottom: '6px'}} src='/assets/og.svg' alt=""/>
            </ButtonContent>
          </IconButton>
        </ModalContentHolder>
      </MintModalPhaseOne>
    ),
    (
      <MintModalPhaseOne>
        <ModalContentHolder>
          <Content>
            WANT SOME <SelectedText>NEW ACTION FIGURES TOO?</SelectedText>
          </Content>
        </ModalContentHolder>
        <Figures src="/assets/mint_figures.png"/>
        <ModalContentHolder>
          <Content style={{fontSize: '1.25rem'}}>
            New Action Figures have <SelectedText style={{fontWeight: 400}}>upgradable bodies</SelectedText>, and come in <SelectedText style={{fontWeight: 400}}>three new body types</SelectedText> to give you a complete and <SelectedText>unstoppable Broadside team</SelectedText>.  
          </Content>
        </ModalContentHolder>
        <ModalContentHolder>
          <SliderContainer>
            <MintModalSlider max={100} onChange={(value)=>{setMintFigures(value)}} value={mintFigures}/>
            <IconButton
              animated={true}
              backgroundOverwrite={theme.buttonGreen}
              backgroundOverwriteHover={theme.buttonLightGreen}
              borderOverwrite='rgba(0, 0, 0, .16)'
              onClick={onAddNewFigures}>
              <ButtonContent>
                <img style={{paddingBottom: '6px'}} src='/assets/bj.svg' alt=""/>
                <div>Add {mintFigures} New Action Figure{mintFigures > 1 ? 's' : ''}</div>
                <img style={{paddingBottom: '6px'}} src='/assets/bj.svg' alt=""/>
              </ButtonContent>
            </IconButton>
          </SliderContainer>    
        </ModalContentHolder>
        <ModalContentHolder>
          <IconButton
            animated={true}
            onClick={onMintOgs}>
            <ButtonContent>
              <img style={{paddingBottom: '6px'}} src='/assets/og.svg' alt=""/>
              <div>Just mint OGs</div>
              <img style={{paddingBottom: '6px'}} src='/assets/og.svg' alt=""/>
            </ButtonContent>
          </IconButton>
        </ModalContentHolder>
      </MintModalPhaseOne>
    )
  ]

  return (
    <AppModal>
      <StyledMintModal>
        <MintModalHeader title={titles[phase]}/>
        <ModalContentBackground>
          {phases[phase]}
        </ModalContentBackground>
      </StyledMintModal>      
    </AppModal>
  )
}

export default MintModal
